module.exports = __webpack_public_path__ + "img/scan.603b670c.svg";